export const header = {
    logo: {
        brandName: 'Fronteira Sul Drones',
        tagline: 'Soluciones en Drones',
        ariaLabel: 'Ir al inicio de la página',
    },
    navigation: {
        home: 'Inicio',
        drones: 'Drones',
        newDrones: 'Drones Nuevos',
        usedDrones: 'Drones Usados',
        buffalo: 'Línea Buffalo',
        powerCitros: 'Power Citros',
        parts: 'Piezas',
        services: 'Servicios',
        about: 'Acerca de',
        contact: 'Contacto',
    },
    mobileMenu: {
        toggleAriaLabel: 'Alternar menú',
        closeAriaLabel: 'Cerrar menú',
    },
    actions: {
        search: 'Buscar',
        cart: 'Carrito',
        account: 'Cuenta',
        toggleTheme: 'Alternar tema',
        back: 'Volver',
    },
    catalog: {
        title: 'Catálogo',
    },
};
//# sourceMappingURL=header.js.map